import { controls, currencyToNumber, grouped } from "../../controls";
  
const rpsl9 = {
  label: "Govt Sponsored Recovery SLBC",
  starting: true,
  url: "rpsl9",
  pageLabel: "Govt Sponsored Recovery SLBC",
  pageType: "history",
  // filteraction: true,
  filter: [

    ...controls.displayText({ tab: "filter", label: "Reporting Season", star: true }),
    ...controls.autoComplete({ tab: "filter", name: "manual_report_master_code", width: "col-sm-2", controlType: "ManualReportMaster" }),
    ...controls.displayText({ tab: "filter", label: "" }),

  ],
  form: [],
  history: {
    perPage: 50,
    reportHeader: "Govt Sponsored Recovery SLBC",
    filterable: true,
    sortable: true,
    defaultsTo: 0,
    pdfProps: {
      pageSize: "A4", pageOrientation: "portrait"
    },
    textReportProps: {
      'slbc': {
        filename: `Govt Sponsored Recovery.txt`,
        format: {},
        separator: "|"
      },
    },


    displayColumns: [

      {
        Header: "State Code",
        accessor: "slbc_state_no",

      },

      {
        Header: "District Code",
        accessor: "slbc_district_no",

      },

      {
        Header: "Block Code",
        accessor: "slbc_block_code",

      },


      {
        Header: "DAY_NRLM Outstanding A/c",
        accessor: "day_nrlm_outstanding_ac"

      },
      {
        Header: "DAY_NRLM Outstanding Amount",
        accessor: "day_nrlm_outstanding_amt",
        type: "currency"
      },


      {
        Header: "DAY_NRLM irregular A/C",
        accessor: "day_nrlm_irregular_ac"

      },
      {
        Header: "DAY_NRLM irregular Amount",
        accessor: "day_nrlm_irregular_amt",
        type: "currency"
      },

      {
        Header: "DAY_NRLM NPA A/c",
        accessor: "day_nrlm_npa_ac"

      },
      {
        Header: "DAY_NRLM NPA Amount",
        accessor: "day_nrlm_npa_amt",
        type: "currency"
      },


      {
        Header: "DAY_NULM Outstanding A/c",
        accessor: "day_nulm_outstanding_ac"

      },
      {
        Header: "DAY_NULM Outstanding Amount",
        accessor: "day_nulm_outstanding_amt",
        type: "currency"
      },

      {
        Header: "DAY_NULM NPA A/c",
        accessor: "day_nulm_npa_ac"

      },
      {
        Header: "DAY_NULM NPA Amount",
        accessor: "day_nulm_npa_amt",
        type: "currency"
      },


      {
        Header: "Total PMEGP Outstanding A/c",
        accessor: "total_pmegp_outstanding_ac"

      },
      {
        Header: "Total PMEGP Outstanding Amount",
        accessor: "total_pmegp_outstanding_amt",
        type: "currency"
      },

      {
        Header: "Total PMEGP NPA A/c",
        accessor: "total_pmegp_npa_ac"

      },
      {
        Header: "Total PMEGP Amount",
        accessor: "total_pmegp_npa_amt",
        type: "currency"
      },

      {
        Header: "SHG Outstanding A/c",
        accessor: "shg_outstanding_ac"

      },
      {
        Header: "SHG Outstanding Amount",
        accessor: "shg_npa_amt",
        type: "currency"
      },

      {
        Header: "SHG NPA A/c",
        accessor: "shg_npa_ac"

      },
      {
        Header: "SHG NPA Amount",
        accessor: "shg_npa_amt",
        type: "currency"
      },

      {
        Header: "SUI Outstanding A/c",
        accessor: "sui_outstanding_ac"

      },
      {
        Header: "SUI Outstanding Amount",
        accessor: "sui_outstanding_amt",
        type: "currency"
      },

      {
        Header: "SUI NPA A/c",
        accessor: "sui_npa_ac"

      },
      {
        Header: "SUI NPA Amount",
        accessor: "sui_npa_amt",
        type: "currency"
      },

    ]
  }
};

export default rpsl9;